(function actionsDefinition() {
    'use strict';
    angular.module('Entities')
        .service('actionService', [
            'restUrlBuilder', function actionService(restUrlBuilder) {
                this.get = function () {
                    return restUrlBuilder('auth').all('action')
                                                 .get();
                };
            }
        ]);
})();